import { FC } from "react";
import { isValidSubMenu } from "@utils/app.util";
import { Button } from "@components/button";
import { CustomTooltip } from "@components/tool-tip";
import { DownArrow, UpArraow } from "@components/icons";
import { useActiveMenu } from "@contexts/active-menu-state.context";
import { AppMenuSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";

interface MenuProps {
  menuData: AppMenuSchemaType[];
  appId?: string;
  className?: string;
  fontColor?: string;
  bgColor?: string;
  toggleLeftMenu?: (value?: boolean) => void;
}

export const Menu: FC<MenuProps> = ({
  menuData,
  appId,
  className,
  fontColor,
  bgColor,
  toggleLeftMenu,
}) => {
  const { activeMenu, expandedSubMenus, onMenuClick } = useActiveMenu();
  return (
    <ul className="top-menu">
      {menuData?.map((menu) => {
        if (!menu) return;
        const isActive = menu?._id === activeMenu;
        const isSubMenu = isValidSubMenu(menu);
        const isSubmenuOpen = isSubMenu && !!expandedSubMenus?.[menu?._id as string];
        return (
          <li
            key={menu._id}
            className={`${className} ${isSubMenu ? "parentMenu" : ""} ${
              isSubmenuOpen ? "showMenu" : "hideMenu"
            }`}
            style={{
              backgroundColor: isActive ? bgColor : "inherit",
              borderBottom:
                menu?.addSeperatorBelow && !isSubmenuOpen ? `1px solid ${fontColor}` : "",
            }}
          >
            <Button
              style={{ color: fontColor }}
              className={`menu-btn display-mobile ${isActive ? "active-menu" : ""} `}
              variant="transparent"
              onClick={() => {
                onMenuClick(menu, isSubMenu, appId as string);
                if (!isSubMenu) {
                  toggleLeftMenu?.();
                }
              }}
            >
              {menu?.title}
              {isSubMenu &&
                (isSubmenuOpen ? (
                  <UpArraow size="15" color={fontColor} />
                ) : (
                  <DownArrow size="15" color={fontColor} />
                ))}
            </Button>
            <Button
              style={{ color: fontColor }}
              className={`menu-btn display-desktop ${isActive ? "active-menu" : ""} `}
              variant="transparent"
              onClick={() => {
                onMenuClick(menu, isSubMenu, appId as string);
              }}
            >
              <CustomTooltip delay={2} direction="right" content={menu?.title}>
                {menu?.title}
              </CustomTooltip>
              {isSubMenu &&
                (isSubmenuOpen ? (
                  <UpArraow size="15" color={fontColor} />
                ) : (
                  <DownArrow size="15" color={fontColor} />
                ))}
            </Button>
            {/* If the menu is collapsed, place the separator right below the title */}
            {/* {menu?.addSeperatorBelow && !isSubmenuOpen && (
              <hr className="seperator" style={{ backgroundColor: fontColor }} />
            )} */}
            {isSubmenuOpen && (
              <>
                <Menu
                  menuData={menu?.children as AppMenuSchemaType[]}
                  appId={appId}
                  className="submenu"
                  fontColor={fontColor}
                  bgColor={bgColor}
                  toggleLeftMenu={toggleLeftMenu}
                />
                {/* If the menu is expanded, move the separator to the last submenu item */}
                {menu?.addSeperatorBelow && (
                  <hr className="seperator" style={{ backgroundColor: fontColor }} />
                )}
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
};
